<template>
  <v-container fluid style = 'padding:0;'>
    <div class = 'status-wrapper'>

      <!-- Alerts -->
      <v-snackbar v-if="showErrorAlert" type="error">There was an error doing this operation. Message: {{ errorMessage }}</v-snackbar>

      <!-- Decline In progress -->
      <div v-if="isLoaded&&booking&&!isStatusChanged&&booking.current_status=='ready_for_option_selection'&&booking_schedule_options.length>0&&isDeclineMode&&!declineComplete" class = 'content-item'>

        <h1 v-if="isLoaded">Appointment Options</h1>

        <div class = 'explain-icon'>
          <v-icon>mdi-emoticon-sad-outline</v-icon>
        </div>
        <div class = 'explain-title'>
          Oh no!
        </div>
        <div class = 'explain-message'>
          Uh oh Sorry none of those options work for you, we'll get back to you ASAP with some more options.
        </div>

        <div class = 'decline-reason-wrapper'>
          <v-textarea v-model="declineReason" placeholder="Enter your answer" rows="3"
            variant="outlined"
            hide-details
          ></v-textarea>
        </div>            
        <div class = 'button-wrapper'>
          <v-btn @click="isDeclineMode=false" :disabled="updateUnderway" variant = 'outlined'>Back</v-btn>
          <v-btn @click="decline()" :disabled="updateUnderway" variant = 'tonal' class = 'decline-confirm-button'>Confirm</v-btn>
        </div>
      </div>

      <!-- Decline Complete -->
      <div v-if="isLoaded&&booking&&!isStatusChanged&&booking.current_status=='ready_for_option_selection'&&booking_schedule_options.length>0&&isDeclineMode&&declineComplete" class = 'content-item'>

        <h1 v-if="isLoaded">Appointment Options</h1>

        <div class = 'explain-icon'>
          <v-icon>mdi-emoticon-sad-outline</v-icon>
        </div>
        <div class = 'explain-title'>
          Oh no!
        </div>
        <div class = 'explain-message'>
          Sorry to hear none of those options worked for you.
        </div>
        <div class = 'explain-message'>
          Our team will be in touch with you soon with additional options.
        </div>

        <div class = 'button-wrapper'>
          &nbsp;
        </div>          

      </div>


      <!-- Option Selection Mode: Thank You -->
      <div v-if="isLoaded&&booking&&!isStatusChanged&&booking.current_status=='ready_for_option_selection'&&booking_schedule_options.length>0&&!isDeclineMode&&isConfirmMode&&isThankYou" class = 'content-item'>

        <div class = 'explain-icon'>
          <v-icon>mdi-emoticon-happy-outline</v-icon>
        </div>

        <div class = 'explain-title'>
          Thank you!
        </div>          

        <div class = 'explain-message'>
          Your booking is confirmed. 
        </div>          

        <div class = 'explain-message'>
          We'll reach out shortly if we require any more information.
        </div>

        <div class = 'explain-message'>
          If this is your first HealthCasa appointment, your appointment is not confirmed until your payment information has been added to your profile. Please look out for an email from us.
        </div>

        <div class = 'explain-message'>
          <p>Need a change? <a href = 'mailto:info@healthcasa.com' target = '_new'>Email us</a> or <a href = 'sms:+16476915150' target = '_new'>Text us</a>.</p>
        </div>

        <div>&nbsp;</div>

      </div>

      <!-- Option Selection Mode: Confirm -->
      <div v-if="isLoaded&&booking&&!isStatusChanged&&booking.current_status=='ready_for_option_selection'&&booking_schedule_options.length>0&&!isDeclineMode&&isConfirmMode&&!isThankYou" class = 'content-item'>

        <h1 v-if="isLoaded">Appointment Options</h1>

        <div class = 'explain-icon'>
          <v-icon>mdi-emoticon-happy-outline</v-icon>
        </div>
        <div class = 'explain-title'>
          Almost there!
        </div>
        <div class = 'explain-message'>
          Please confirm the details of your booking and Submit.
        </div>

        <div class = 'confirm-details'>

          <div>
            <div>
              <v-icon>mdi-account</v-icon>                
            </div>
            <div>
              <p>{{ selected_booking_schedule_option.practitioner_label }}</p>
            </div>
          </div>
          <div>
            <div>
              <v-icon>mdi-heart</v-icon>                
            </div>
            <div>
              <p>{{ booking.treatment_category_display_name }}</p>
            </div>
          </div>
          <div>
            <div>
              <v-icon>mdi-calendar</v-icon>                
            </div>
            <div>
              <p>{{ selected_booking_schedule_option.schedule_date_local_date_nice }}</p>
            </div>
          </div>
          <div>
            <div>
              <v-icon>mdi-clock</v-icon>                
            </div>
            <div>
              <p>{{ selected_booking_schedule_option.schedule_date_local_time_nice }}</p>
            </div>
          </div>

        </div>

        <div class = 'button-wrapper'>
          <v-btn @click="isConfirmMode=false" :disabled="updateUnderway" variant="outlined">Back</v-btn>
          <v-btn @click="saveSelectOption()" :disabled="updateUnderway" variant="tonal">Submit</v-btn>
        </div>

      </div>

      <!-- Option Selection Mode: Select -->
      <div v-if="isLoaded&&booking&&!isStatusChanged&&booking.current_status=='ready_for_option_selection'&&booking_schedule_options.length>0&&!isDeclineMode&&!isConfirmMode" class = 'content-item'>

        <h1 v-if="isLoaded">Appointment Options</h1>

        <div class = 'section-descriptor' v-if="isLoaded&&!isConfirmMode">
          <div>
            <v-icon>mdi-clock-time-five</v-icon>
          </div>
          <div>
            <h2>Please select one time slot based on the availabilities of the practitioners below.</h2>
          </div>            
        </div>
        
        <div v-for="practitioner in prepared_options" v-bind:key="practitioner.practitioner_id">

          <div class = 'practitioner-title'>{{ practitioner.practitioner_label }} 
            <a href = 'javascript:void(0)' v-if="practitioner.practitioner_bio" @click="practitioner.show_bio=!practitioner.show_bio" class = 'bio-expand-link'>
                <v-icon v-show="practitioner.show_bio===false" aria-label="Show Practitioner Bio">mdi-account-circle</v-icon>
              <v-icon v-show="practitioner.show_bio===true" aria-label = "Hide Practitioner Bio">mdi-account-circle-outline</v-icon>
            </a>
          </div>

          <p v-show="practitioner.practitioner_bio&&practitioner.show_bio" class = 'bio-practitioner'>{{ practitioner.practitioner_bio }}</p>

          <div v-for="date in practitioner.dates" v-bind:key="date.schedule_date_local_date_nice">

            <div class = 'option-date-title'>{{ date.schedule_date_local_date_nice }}</div>

            <div class = 'option-times'>

              <v-btn v-for="option in date.options" v-bind:key="option.id" v-bind:class="{ 'active': option.booking_schedule_option_id == selected_booking_schedule_option_id }" 
                  @click="toggleSelectedOption(option.booking_schedule_option_id)" variant="outlined">
                {{ option.schedule_date_local_time_nice }}
              </v-btn>

            </div>
          </div>

        </div>

        <div class = 'form-error' v-if="selectError">
          {{ selectError }}

        </div>
        
        <div class = 'button-wrapper'>
          <v-btn @click="selectOption()" :disabled="updateUnderway" variant="tonal" class = 'small'>Select &amp; Continue</v-btn>
          <v-btn @click="isDeclineMode=true" :disabled="updateUnderway" variant="outlined" class = 'decline-button small'>Send More Options</v-btn>            
        </div>

      </div>

      <!-- Not available -->
      <div v-if="isLoaded&&booking&&!isStatusChanged&&(booking.current_status=='new'||booking.current_status=='waiting_for_practitioners'||booking.current_status=='awaiting_admin')" class = 'content-item'>

        <div class = 'explain-icon'>
          <v-icon>mdi-emoticon-happy-outline</v-icon>
        </div>
        <div class = 'explain-title'>
          Thank you for your patience!
        </div>
        <div class = 'explain-message'>
          We're working on your request and you'll be notified as soon as we have some options for you!
        </div>

        <div class = 'button-wrapper'>
          &nbsp;
        </div>

      </div>
      <!-- Cancelled -->
      <div v-else-if="isLoaded&&booking&&!isStatusChanged&&booking.current_status=='admin_cancelled'" class = 'content-item'>

        <div class = 'explain-icon'>
          <v-icon>mdi-emoticon-sad-outline</v-icon>
        </div>
        <div class = 'explain-title'>
          Oh no!
        </div>
        <div class = 'explain-message'>
          Your booking has been cancelled. 
        </div>
        <div class = 'explain-message'>
          Still want to book?
        </div>          
        <div class = 'explain-message'>
          Click below to get started.
        </div>                
        <div class = 'explain-message'>
          <p>Please <a href = 'mailto:info@healthcasa.com' target = '_new'>Email us</a> or <a href = 'sms:+16476915150' target = '_new'>Text us</a> if you require any further assistance.</p>
        </div>

        <div class = 'button-wrapper center'>
          <v-btn @click="startNewBooking()" variant="tonal">Start Again</v-btn>
        </div>          

      </div>
      <!-- Client Unsubscribe -->
      <div v-else-if="isLoaded&&booking&&!isStatusChanged&&booking.current_status=='client_unsubscribe'" class = 'content-item'>

        <div class = 'explain-icon'>
          <v-icon>mdi-emoticon-sad-outline</v-icon>
        </div>
        <div class = 'explain-title'>
          Oh no!
        </div>
        <div class = 'explain-message'>
          Your booking has been cancelled. 
        </div>
        <div class = 'explain-message'>
          <p>Please <a href = 'mailto:info@healthcasa.com' target = '_new'>Email us</a> or <a href = 'sms:+16476915150' target = '_new'>Text us</a> if you require any further assistance.</p>
        </div>

        <div class = 'button-wrapper'>
          &nbsp;
        </div>          

      </div>

      <!-- All others, after selection -->
      <div v-else-if="isLoaded&&booking&&!isStatusChanged&&(booking.current_status=='confirmed'||booking.current_status=='waiting_for_processing'||booking.current_status=='processed')">

        <div class = 'explain-icon'>
          <v-icon>mdi-emoticon-happy-outline</v-icon>
        </div>

        <div class = 'explain-title'>
          Your Booking is Confirmed!
        </div>  

        <div class = 'confirm-details' v-if="booking_schedule_option_confirmed">

          <div>
            <div>
              <v-icon>mdi-account</v-icon>                
            </div>
            <div>
              <p>{{ booking_schedule_option_confirmed.practitioner_label }}</p>
            </div>
          </div>
          <div>
            <div>
              <v-icon>mdi-heart</v-icon>                
            </div>
            <div>
              <p>{{ booking.treatment_category_display_name }}</p>
            </div>
          </div>
          <div>
            <div>
              <v-icon>mdi-calendar</v-icon>                
            </div>
            <div>
              <p>{{ booking_schedule_option_confirmed.schedule_date_local_date_nice }}</p>
            </div>
          </div>
          <div>
            <div>
              <v-icon>mdi-clock</v-icon>                
            </div>
            <div>
              <p>{{ booking_schedule_option_confirmed.schedule_date_local_time_nice }}</p>
            </div>
          </div>

        </div>


        <div class = 'button-wrapper'>
          &nbsp;
        </div>          

      </div>


      <!-- All others, after selection -->
      <div v-else-if="isLoaded&&booking&&!isStatusChanged&&booking.current_status!='ready_for_option_selection'">

        <div class = 'explain-icon'>
          <v-icon>mdi-emoticon-happy-outline</v-icon>
        </div>
        <div class = 'explain-title'>
          Thank you for your patience!
        </div>
        <div class = 'explain-message'>
          We're working on your request and you'll be notified as soon as we have some options for you!
        </div>

        <div class = 'button-wrapper'>
          &nbsp;
        </div>          

      </div>

      <div v-else-if="isLoaded&&booking&&isStatusChanged" class = 'content-item'>

        <div class = 'explain-icon'>
          <v-icon>mdi-emoticon-sad-outline</v-icon>
        </div>
        <div class = 'explain-title'>
          Oh no!
        </div>
        <div class = 'explain-message'>
          Sorry, the status of this booking changed while you were loading this page, please reload this page.
        </div>
        
        <div class = 'button-wrapper'>
          &nbsp;
        </div>

      </div>
      <div v-else-if="isLoaded&&!booking" class = 'content-item'>

        <div class = 'explain-icon'>
          <v-icon>mdi-emoticon-sad-outline</v-icon>
        </div>
        <div class = 'explain-title'>
          Oh no!
        </div>
        <div class = 'explain-message'>
          Unfortunately, we can't find that booking.
        </div>
        <div class = 'explain-message'>
          <p>Please <a href = 'mailto:info@healthcasa.com' target = '_new'>Email us</a> or <a href = 'sms:+16476915150' target = '_new'>Text us</a> if you require any further assistance.</p>
        </div>

        <div class = 'button-wrapper'>
          &nbsp;
        </div>          

      </div>


    </div>

  </v-container>
</template>

<script>
import axios from 'axios';
import api from '@/api.js';
import logo from '@/assets/logo.webp';

export default {
  name: 'BookingStatusView',
  components: { 
  },    
  data() {
      return {
          logo,
          isLoaded: false,
          code: null,
          updateUnderway: false,
          isStatusChanged: false,

          booking: null,
          booking_schedule_options: [],
          booking_schedule_option_confirmed: null,
          prepared_options: [],


          showErrorAlert: false,
          errorMessage: '',

          isDeclineMode: false,
          declineComplete: false,
          declineReason: '',
          isConfirmMode: false,
          selected_booking_schedule_option_id: null,
          selected_booking_schedule_option: null,
          selectError: '',
          isThankYou: false,


          statusPollLength: 30000            
      }
  },
  methods: {

    async backgroundPollStatus() {
      if(!this.isLoaded || !this.booking || this.isThankYou || this.declineComplete) {
        return;
      }

      let headers = await api.getApiHeaders();
      try {
        let response = await axios.get(api.getApiUrl('u/booking-status/info/' + this.code), { headers });
        if(response.data.booking.current_status != this.booking.current_status) {
          this.isStatusChanged = true;
        } else {
          setTimeout(this.backgroundPollStatus, this.statusPollLength);
        }
      } catch (error) {
        console.error('Error:', error);
      }
    },
    
    prepareOptions() {
      let foundPractitioners = {};
      for (let option of this.booking_schedule_options) {
        if (!foundPractitioners[option.practitioner_id]) {
          foundPractitioners[option.practitioner_id] = {
            practitioner_id: option.practitioner_id,
            practitioner_label: option.practitioner_label,
            practitioner_bio: option.practitioner_bio,
            show_bio: false,
            options: []
          };
        }
        foundPractitioners[option.practitioner_id].options.push(option);
      }

      // for each, group by date
      for (let practitioner_id in foundPractitioners) {
        let practitioner = foundPractitioners[practitioner_id];
        practitioner.dates = [];
        let foundDates = {}
        for (let option of practitioner.options) {
          if(option.schedule_date_local_date_nice in foundDates) {
            practitioner.dates[foundDates[option.schedule_date_local_date_nice]].options.push(option);
          } else {
            foundDates[option.schedule_date_local_date_nice] = practitioner.dates.length;
            practitioner.dates.push({
              schedule_date_local_date_nice: option.schedule_date_local_date_nice,
              options: [option]
            });
          }
        }
      }

      this.prepared_options = Object.values(foundPractitioners);
    },
    toggleSelectedOption(option_id) {
      if(this.selected_booking_schedule_option_id == option_id) {
        this.selected_booking_schedule_option_id = null;
      } else {
        this.selected_booking_schedule_option_id = option_id;
      }
    },

    selectOption() {
      if(this.selected_booking_schedule_option_id == null) {
        this.selectError = "Please select an option";
        return;
      } 
      this.isConfirmMode = true;
    },

    async saveSelectOption() {
      if(this.selected_booking_schedule_option_id == null) {
        this.errorMessage = "Please select an option";
        this.showErrorAlert = true;
        return;
      } 
      this.errorMessage = "";
      try {
        let params = {
          booking_schedule_option_id: this.selected_booking_schedule_option_id
        };
        let headers = await api.getApiHeaders();
        await axios.put(api.getApiUrl('u/booking-status/select-option/' + this.code), params, { headers });

        this.isThankYou = true;

      } catch (error) {
        console.error('Error:', error);
        if (error.response && error.response.data.detail) {
          this.errorMessage = error.response.data.detail;
        } else {
          this.errorMessage = 'Unable to select option';
        }
        this.showErrorAlert = true;
      }   
    },

    async load() {
      let headers = await api.getApiHeaders();
      try {
        let response = await axios.get(api.getApiUrl('u/booking-status/info/' + this.code), { headers });

        this.booking = response.data.booking;
        this.booking_schedule_options = response.data.booking_schedule_options;
        this.booking_schedule_option_confirmed = response.data.booking_schedule_options.length ? response.data.booking_schedule_options[0] : null; // first option if status is confirmed
        this.prepareOptions();
        if(this.booking.current_status == 'ready_for_option_selection') {
          setTimeout(this.backgroundPollStatus, this.statusPollLength);
        }
      } catch (error) {
        console.error('Error:', error);
        if (error.response && error.response.data.detail) {
          this.errorMessage = error.response.data.detail;
        } else {
          this.errorMessage = 'Unable to get booking.';
        }
        this.showErrorAlert = true;
      }          
    },



    async loadRefresh() {
      await this.load();
      this.isLoaded = true;
    },
    async decline() {
      if(this.declineReason == '') {
        this.errorMessage = 'Please provide a reason for declining.';
        this.showErrorAlert = true;
        return;
      } 

      this.errorMessage = '';
      this.showErrorAlert = false;
      try {
        this.updateUnderway = true;
        let headers = await api.getApiHeaders();
        await axios.put(api.getApiUrl('u/booking-status/decline-all-options/' + this.code), { reason: this.declineReason }, { headers });
        this.declineComplete = true;
      } catch (error) {
        console.error('Error:', error);
        if (error.response && error.response.data.detail) {
          this.errorMessage = error.response.data.detail;
        } else {
          this.errorMessage = 'Unable to decline booking.';
        }
        this.showErrorAlert = true;
      } finally {
        this.updateUnderway = false;
      }
    },

    startNewBooking() {
      this.$router.push('/');
    }      


  },
  async mounted() {
      let split_by_slash = this.$route.path.split("/");
      this.code = split_by_slash[split_by_slash.length - 1];
      await this.loadRefresh();
  },
  watch: {
    'selected_booking_schedule_option_id': function() {
      // look-up related option
      this.selected_booking_schedule_option = null;
      if(this.selected_booking_schedule_option_id) {
        for (let booking_schedule_option of this.booking_schedule_options) {
          if (booking_schedule_option.booking_schedule_option_id == this.selected_booking_schedule_option_id) {
            this.selected_booking_schedule_option = booking_schedule_option;
            break;
          }
        }
      }
    }
  }

};
</script>
<style lang="scss">

$primaryDark: #32598C;
$primaryLight: #00B0DA;
$accent: #F25631;
$error: #FF4B55;
$errorHover: #CC3C44;
$button: #00B0DA;
$warningOrange: #F26531;

DIV.status-wrapper {
> DIV.content-item {
  height:calc(100vh - 243px);
  display:flex;
  flex-direction:column;
  justify-content:space-between;

  @media (max-width: 1250px) {
    height:calc(100vh - 247px);
  }
}
}

DIV.practitioner-title {
font-size: 15px;
font-weight:700;
margin-top: 20px;
color: $primaryDark;
}

DIV.option-date-title {
font-size: 15px;
font-weight:500;
margin-top: 5px;
color: $primaryDark;
}

DIV.option-times {
margin-bottom:10px;

@media (max-width: 1250px) {      
  overflow-x: auto; 
  overflow-y: hidden;
  white-space: nowrap; 
  width:100%;
  /* Hide scrollbar */
  -ms-overflow-style: none;  /* IE and Edge */
  scrollbar-width: none;  /* Firefox */  
  &::-webkit-scrollbar {
    display: none;
  }
  /* Fade the right edge */
  &::after {
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    width: 50px;
    height: 100%;
    background: linear-gradient(to right, rgba(255, 255, 255, 0), white);
  }
}

> BUTTON {
  margin-right: 10px;
  margin-top: 10px;
  border: 1px solid #00000033;
  border-radius: 9px;
  font-weight:500;
  padding-left:10px;
  padding-right:10px;
  &.active {
    background-color: $accent;
    color: white;
    font-weight:600;
    padding-left:9px;
    padding-right:9px;      
  }
  transition: none !important;
}
}

.button-wrapper BUTTON.v-btn--variant-outlined {
&.decline-button {
  color: #FFF;
  border: 1px solid $warningOrange;
  background-color: $warningOrange !important;
  &:hover {
    background-color: darken($warningOrange, 5%) !important;
    border: 1px solid darken($warningOrange, 5%);
    color:#FFF;
  }      
}
}

.button-wrapper BUTTON {
&.decline-confirm-button {
  color: #FFF;
  border: 1px solid $warningOrange;
  background-color: $warningOrange !important;
  &:hover {
    background-color: darken($warningOrange, 5%) !important;
    border: 1px solid darken($warningOrange, 5%);
    color:#FFF;
  }      
}
}

DIV.explain-icon {
margin-top:20px;
text-align:center;
font-size: 45px;
color: $accent;
}

DIV.explain-title {
text-align:center;
font-size: 18px;
font-weight:700;
color: $primaryDark;
margin-top:20px;
}

DIV.explain-message {
font-size: 15px;
font-weight:500;
color: $primaryDark;
margin-top:20px;
margin-left:auto;
margin-right:auto;
width:250px;
text-align:center;
}

DIV.decline-reason-wrapper {
margin-top:20px;
}

DIV.confirm-details {
margin-top:20px;
padding:20px;
border: 1px solid rgba(0, 0, 0, 0.4);
border-radius: 9px;
font-size:16px;

> DIV {
  display:flex;
  margin-top:10px;
  &:first-child {
    margin-top:0;
  }
  > DIV {
    margin-right:10px;
    color:$accent;
  }
  > DIV:last-child {
    font-weight:600;
    color:$primaryDark;
  }
}
}


.thankyou-overlay-content {
width:300px;
min-height:360px;
background-color:#FFF;
border-radius: 9px;
padding:30px;
padding-left:40px;
padding-right: 40px;

> DIV.icon-element {
  text-align:center;
  font-size: 60px;
  color: $accent;
}

> H2 {
    -align:center;
  font-size: 18px;
  font-weight:700;
  color: $primaryDark;
  margin-top:20px;
}

> DIV.thankyou-overlay-description {
  text-align:center;
  font-size: 20px;
  color: $primaryDark;
  margin-top:20px;    
  font-size:15px;
  font-weight:500;  

  A {
    color: $accent;
    text-decoration: underline;
  }
}

}

.form-error {
margin-top:20px;
color: $error;
font-size:15px;
font-weight:500;
}

.bio-expand-link {
  color: $accent;
}

.bio-practitioner {
  font-size: 15px;
  font-weight:500;
  color: $primaryDark;
  margin-top:10px;
}


</style>


